import request from '../../shared/lib/request'

function fetchGroup(page) {
    return request({
        url: `/album/group`,
        method: 'POST',
        data: {
            page,
        }
    });
}

const AlbumService = {
    fetchGroup
}

export default AlbumService;
